module.exports = __webpack_public_path__ + "img/canbadge-round-38mm-asa_line.a97a0124.png";